const styles = `:host {
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  display: inline-flex;
  gap: var(--goto-spacing-02);
  align-items: center;
}
:host .label {
  font: var(--goto-body-small);
  color: var(--goto-type-color-default);
}
:host .switch {
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  position: relative;
  width: var(--goto-spacing-08);
  height: var(--goto-spacing-05);
  background: var(--goto-surface-color-tertiary);
  box-sizing: border-box;
  border-radius: var(--goto-radius-large);
  cursor: pointer;
  transition: all 0.25s ease-out;
}
:host .switch::before {
  position: absolute;
  content: "";
  background: var(--goto-icon-color-inverted);
  border-radius: var(--goto-radius-circle);
  box-shadow: var(--goto-elevation-small);
  width: var(--goto-spacing-04);
  height: var(--goto-spacing-04);
  transform: translate(1px, 1px);
  transition: all 70ms cubic-bezier(0.4, 0.14, 0.3, 1);
}
:host .checked-message {
  display: none;
}
:host .unchecked-message {
  display: none;
}

:host(:focus),
:host(:focus-visible) {
  outline: none;
}

:host(:focus-visible) .switch {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
}

:host(.checked) .switch {
  background: var(--goto-interactive-color-brand-default);
}
:host(.checked) .switch::before {
  transform: translate(21px, 1px);
}

:host(.disabled) .switch {
  cursor: not-allowed;
  background: var(--goto-interactive-color-disabled);
}
:host(.disabled) .switch::before {
  box-shadow: none;
  background: var(--goto-icon-color-inverted);
}

:host([disabled][checked]) .switch {
  background-color: var(--goto-switch-checked-background-disabled);
}`; export default styles;